import { Button, Col, Form, Image, Modal, Row, Spin } from 'antd';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import Message from '../../../../config/Message';
import { useState } from 'react';
import InputComponent from '../../../../component/InputComponent';
import { Notification } from '../../../../config/Global';

const PropertyImageApproveModal = observer((props) => {
	const { visible, onClose, merchantId } = props;
	const [form] = Form.useForm();
	const {
		ACCOMMODATION,
		AUTH,
		ACCOMMODATION: { propertyImageDetails },
	} = useStore();
	const [imageData, setImageData] = useState([]);
	const [disabled, setDisabled] = useState(true);

	const updateImgState = (imgID, versionNo, isApproved) => {
		let imageDetail = {
			refTablename: 'property',
			eRefRecordid: visible,
			id: imgID,
			isApproved: isApproved,
			versionNo: versionNo,
		};
		setImageData((data) => [...data, imageDetail]);
	};

	const handleChange = (imgID, versionNo, checkboxValue) => {
		form.validateFields({ validateOnly: true })
			.then(() => {
				setDisabled(false);
			})
			.catch((err) => {
				setDisabled(true);
			});
		if (imageData.length) {
			const isExist = imageData.find((_x) => _x.id === imgID);
			if (isExist) {
				const removeExist = imageData.filter((_x) => _x.id !== imgID);
				setImageData(removeExist);
				updateImgState(imgID, versionNo, checkboxValue);
			} else {
				updateImgState(imgID, versionNo, checkboxValue);
			}
		} else {
			updateImgState(imgID, versionNo, checkboxValue);
		}
	};

	const handleSubmit = () => {
		AUTH.onApproveImage(imageData).then((data) => {
			if (data) {
				Notification.success({ message: Message().ImageApproved });
				closeModal();
			}
		});
		// onApproveImage;
	};

	const closeModal = () => {
		form.resetFields();
		setImageData([]);
		ACCOMMODATION.propertyImageDetails = null;
		setDisabled(true);
		onClose();
		ACCOMMODATION.getMerchantAccomodation(merchantId.merchantId);
	};
	return (
		<Modal
			title="Property Image Verification"
			onCancel={closeModal}
			open={visible}
			destroyOnClose
			width={'500px'}
			footer={
				<div>
					<Button
						key={1}
						htmlType="submit"
						type="primary"
						disabled={disabled}
						form="imageApprove"
					>
						Submit
					</Button>
					<Button key={2} onClick={closeModal}>
						Cancel
					</Button>
				</div>
			}
		>
			<Spin spinning={!propertyImageDetails}>
				<Form
					id={'imageApprove'}
					layout="vertical"
					form={form}
					onFinish={handleSubmit}
				>
					<Row gutter={24}>
						{propertyImageDetails && propertyImageDetails.length
							? propertyImageDetails.map(
									(imageDetails, index) => {
										return (
											<Col
												span={8}
												style={{ marginBottom: '20px' }}
											>
												<Image.PreviewGroup>
													<Image
														src={`${imageDetails.bunnyLink}?width=300&&aspect_ratio=1:1`}
														alt={
															imageDetails.filename
														}
													/>
													<div
														style={{
															marginTop: '10px',
															textAlign: 'center',
														}}
													>
														<InputComponent
															type={'checkbox'}
															defaultChecked={
																imageDetails.isApproved
															}
															name={`checkbox_${index}`}
															label={'Approve'}
															onChange={(e) =>
																handleChange(
																	imageDetails.id,
																	imageDetails.versionNo,
																	e.target
																		.checked
																)
															}
														/>
													</div>
												</Image.PreviewGroup>
											</Col>
										);
									}
								)
							: Message().noRecord}
					</Row>
				</Form>
			</Spin>
		</Modal>
	);
});

export default PropertyImageApproveModal;
